import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from '../actions/actions';

/* eslint no-unused-vars: 0 */
import ActionsBarHeader from './header/ActionsBarHeader';
import ProgressBarHeader from './header/ProgressBarHeader';

import { LogoWhite } from '../data/images';

import { StepOrder } from '../constants/Steps';

/* eslint eqeqeq: 0 */
export class Header extends Component {
    goToIndex() {
        browserHistory.push('/');
    }

    renderActionsBar() {
        return (
            <ActionsBarHeader stepIndex={ this.props.stepIndex } />
        );
    }

    renderTitle() {
        if (this.props.url && !this.props.url.split('/')[0]) {
            return '';
        }

        return this.props.title || '';
    }

    render() {
        let logoHiddenMobileClass = '';
        if (this.props.stepIndex != null) {
            logoHiddenMobileClass = 'hidden-mobile';
        }

        return <div className="app__header__wrapper">
            <div className="app__header__container">
                <div className="app__header">
                    <div className={ `app__header__logo ${logoHiddenMobileClass}` } >
                        <img src={ LogoWhite } onClick={ this.goToIndex } />
                    </div>
                    <h1 className="vouchedfor-brand">
                        { this.renderTitle() }
                    </h1>
                    { this.renderActionsBar() }
                </div>
            </div>
        </div>;
    }
}

Header.propTypes = {
    url: React.PropTypes.string,
    stepIndex: React.PropTypes.number,
    title: React.PropTypes.string,
    actions: React.PropTypes.object,
};

function mapStateToProps(state) {
    return {
        stepIndex: state.navigation.get('stepIndex'),
        title: state.navigation.get('title'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx